import styled from 'styled-components'

// Note: each toast keeps an 8px margin below it (the exit animation shrinks it so the rest slide
// down smoothly - a flex gap can't animate), so the container sits 8px lower to keep the last
// toast 16px off the bottom edge
export const ToastContainer = styled.div`
  bottom: ${({ theme }) => theme.space['8']};
  display: flex;
  flex-direction: column;
  left: ${({ theme }) => theme.space['16']};
  position: fixed;
  z-index: ${({ theme }) => theme.zIndex.level4};
`
